import useScrollAnimation from "../hooks/useScrollAnimation";

const Tokenomics = () => {
  const titleRef = useScrollAnimation();
  const gridRef = useScrollAnimation();
  const pillarsRef = useScrollAnimation();

  return (
    <div className="py-[60px] md:py-[100px] w-full bg-[#1a1820] relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#E71CA5] opacity-[0.04] rounded-full blur-[150px]" />

      <div className="container mx-auto px-[6%]">
        <div ref={titleRef} className="animate-on-scroll text-center mb-12 md:mb-16">
          <h3 className="text-[26px] md:text-[47px] font-bold font-Poppins text-white">
            <span className="gradient-text">$SHIT Utility</span>
          </h3>
          <p className="font-Poppins text-white/50 mt-4 max-w-2xl mx-auto text-base md:text-lg">
            More than a meme coin — the engine funding sustainable food systems
            through wealth creation.
          </p>
        </div>

        <div ref={gridRef} className="animate-on-scroll">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-[1100px] mx-auto">
            {utilities.map(({ id, icon, title, description }, i) => (
              <div
                key={id}
                className="content-box p-6 group"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="text-3xl mb-3">{icon}</div>
                <h4 className="font-Poppins font-bold text-lg text-white mb-2 group-hover:text-[#E71CA5] transition-colors">
                  {title}
                </h4>
                <p className="font-Poppins text-sm text-white/50 leading-relaxed">
                  {description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Core Innovation Pillars */}
        <div ref={pillarsRef} className="animate-on-scroll mt-16 md:mt-20">
          <h4 className="text-xl md:text-2xl font-Poppins font-bold text-center text-white mb-8">
            Core Innovation Pillars
          </h4>
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-[900px] mx-auto">
            {pillars.map(({ id, icon, label }) => (
              <div
                key={id}
                className="content-box rounded-full px-5 py-3 flex items-center gap-2"
              >
                <span className="text-xl">{icon}</span>
                <span className="font-Poppins font-bold text-sm text-white">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Current Assets Highlight */}
        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[800px] mx-auto">
          {stats.map(({ id, value, label }) => (
            <div
              key={id}
              className="text-center content-box p-6"
            >
              <p className="font-Poppins text-2xl md:text-3xl font-bold gradient-text">
                {value}
              </p>
              <p className="font-Poppins text-sm font-bold uppercase tracking-wider text-white/50 mt-2">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tokenomics;

const utilities = [
  {
    id: 1,
    icon: "\u{1F331}",
    title: "Vertical Farming",
    description:
      "Drive capital into modular, high-yield urban farms using robotics and vertical space to solve food shortages.",
  },
  {
    id: 2,
    icon: "\u{1F404}",
    title: "Beef Associations",
    description:
      "Channel resources into cooperative marketing and sustainable beef production, strengthening regenerative ranching.",
  },
  {
    id: 3,
    icon: "\u{1F30D}",
    title: "Regenerative Grazing",
    description:
      "Back initiatives that restore soil health, generate carbon credits, and reinforce long-term ecological sustainability.",
  },
  {
    id: 4,
    icon: "\u{1F3D9}\u{FE0F}",
    title: "Local Food Security",
    description:
      "Enable deployment of decentralized farms directly into urban centers, ensuring fresh food access where needed.",
  },
  {
    id: 5,
    icon: "\u{1F4E6}",
    title: "D2C Subscriptions",
    description:
      "Bundled produce and beef subscriptions, giving consumers premium food at scale while returning value to holders.",
  },
  {
    id: 6,
    icon: "\u{1F3DB}\u{FE0F}",
    title: "Governance & Profit Sharing",
    description:
      "Token holders shape investment decisions and access early co-op profit sharing, aligning growth with returns.",
  },
];

const pillars = [
  { id: 1, icon: "\u{1F30D}", label: "Earth-Sheltering" },
  { id: 2, icon: "\u{1F4A7}", label: "Aquaponics" },
  { id: 3, icon: "\u{2699}\u{FE0F}", label: "Automation" },
  { id: 4, icon: "\u{2600}\u{FE0F}", label: "Solar Integration" },
  { id: 5, icon: "\u{1F4E6}", label: "High-Density Design" },
  { id: 6, icon: "\u{1F969}", label: "Ag-Protein Synergy" },
];

const stats = [
  { id: 1, value: "130", label: "Acres Held in Trust" },
  { id: 2, value: "$580K", label: "Capital Deployed" },
  { id: 3, value: "2", label: "Blockchains" },
];
